<template>
  <div class="PatternApproveCode">
    <box :title="title">
      <div class="pa-2">
        <v-card class="pa-2">
          <div>
            <strong>وضعیت تائید مرخصی</strong>
          </div>
          <v-row class="mt-1">
            <v-col class="my-auto" cols="12" sm="4">
              <v-select
                v-model="vacationType"
                :items="vacationTypes"
                item-text="Name"
                item-value="Code"
                hide-details=""
                return-object
                class="ma-0 py-0"
                solo
                @change="findVacationPermission"
              ></v-select>
            </v-col>
            <v-col class="mt-1">
              <div class="d-flex">
                <v-spacer></v-spacer>
                <v-select
                  :items="vacationApproveTypes"
                  v-model="vacationApproveType"
                  item-text="Name"
                  item-value="Code"
                  hide-details=""
                  class="ma-0 py-0 ml-2"
                  solo
                ></v-select>
                <v-btn
                  class="my-auto"
                  color="primary"
                  @click="VacationApprove"
                  >{{ $t("submit") }}</v-btn
                >
              </div>
            </v-col>
          </v-row>
        </v-card>

        <v-card class="pa-2 mt-2">
          <div>
            <strong>وضعیت تائید ماموریت</strong>
          </div>
          <v-row class="mt-1">
            <v-col class="my-auto" cols="12" sm="4">
              <v-select
                v-model="missionType"
                :items="missionTypes"
                item-text="Name"
                item-value="Code"
                return-object
                hide-details=""
                class="ma-0 py-0"
                solo
                @change="findMissionPermission"
              ></v-select>
            </v-col>
            <v-col class="mt-1">
              <div class="d-flex">
                <v-spacer></v-spacer>
                <v-select
                  :items="vacationApproveTypes"
                  v-model="missionApproveType"
                  item-text="Name"
                  item-value="Code"
                  hide-details=""
                  class="ma-0 py-0 ml-2"
                  solo
                ></v-select>
                <v-btn
                  class="my-auto"
                  color="primary"
                  @click="MissionApprove"
                  >{{ $t("submit") }}</v-btn
                >
              </div>
            </v-col>
          </v-row>
        </v-card>

        <v-card class="pa-2 mt-2">
          <div>
            <strong>وضعیت تائید ورود و خروج</strong>
          </div>
          <v-row class="mt-1">
            <v-col class="my-auto" cols="12" sm="4"> </v-col>
            <v-col class="mt-1">
              <div class="d-flex">
                <v-spacer></v-spacer>
                <v-select
                  :items="vacationApproveTypes"
                  v-model="ioApproveType"
                  item-text="Name"
                  item-value="Code"
                  hide-details=""
                  class="ma-0 py-0 ml-2"
                  solo
                ></v-select>
                <v-btn class="my-auto" color="primary" @click="IoApprove">{{
                  $t("submit")
                }}</v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card>

        <v-card class="pa-2 mt-2">
          <div>
            <strong>وضعیت تائید اضافه کار</strong>
          </div>
          <v-row class="mt-1">
            <v-col class="my-auto" cols="12" sm="4"> </v-col>
            <v-col class="mt-1">
              <div class="d-flex">
                <v-spacer></v-spacer>
                <v-select
                  :items="vacationApproveTypes"
                  v-model="extraWorkApproveType"
                  item-text="Name"
                  item-value="Code"
                  hide-details=""
                  class="ma-0 py-0 ml-2"
                  solo
                ></v-select>
                <v-btn
                  class="my-auto"
                  color="primary"
                  @click="ExtraWorkApprove"
                  >{{ $t("submit") }}</v-btn
                >
              </div>
            </v-col>
          </v-row>
        </v-card>

        <v-card class="pa-2 mt-2">
          <div>
            <strong>وضعیت تائید اضافه کار ویژه</strong>
          </div>
          <v-row class="mt-1">
            <v-col class="my-auto" cols="12" sm="4"> </v-col>
            <v-col class="mt-1">
              <div class="d-flex">
                <v-spacer></v-spacer>
                <v-select
                  :items="vacationApproveTypes"
                  v-model="spExtraWorkApproveType"
                  item-text="Name"
                  item-value="Code"
                  hide-details=""
                  class="ma-0 py-0 ml-2"
                  solo
                ></v-select>
                <v-btn
                  class="my-auto"
                  color="primary"
                  @click="EspecificExtraWorkApprove"
                  >{{ $t("submit") }}</v-btn
                >
              </div>
            </v-col>
          </v-row>
        </v-card>
      </div>
    </box>
  </div>
</template>

<script>
import ResultType from "../../../model/ResultType";
import ApproveTypes from "../../../model/ApproveTypes";
import PageKind from "../../../model/PageKind";
import EosToastType from "../../../model/EosToastType";
export default {
  data() {
    return {
      title: "",
      args: null,
      vacationType: "",
      vacationTypes: [],
      missionType: "",
      missionTypes: [],
      vacationApproveType: "",
      missionApproveType: "",
      ioApproveType: "",
      extraWorkApproveType: "",
      spExtraWorkApproveType: "",
    };
  },
  mounted() {
    this.pageLoad();
  },
  computed: {
    vacationApproveTypes() {
      return ApproveTypes.VacationApproveTypesArray();
    },
  },
  methods: {
    pageLoad() {
      this.args = this.$route.query;
      var sectionid = this.args.id;
      this.$store
        .dispatch("sections/GetWebSectionsAdmins", { sectionid })
        .then((result) => {
          //console.log(result);
          if (result.type === ResultType.success) {
            if (result.data.Table.length > 0) {
              var adminInfo = result.data.Table[0];
              this.title = `${adminInfo.Name || ""} - ${
                adminInfo.personName || ""
              }`;
            }
          }
        });
      this.loadVacations();
      this.loadMission();
      this.findIOPermission();
      this.findExtraPermission();
      this.FindSpecificExtraworkPermission();

      this.vacationApproveType = this.vacationApproveTypes[0];
      this.missionApproveType = this.vacationApproveTypes[0];
      this.ioApproveType = this.vacationApproveTypes[0];
      this.extraWorkApproveType = this.vacationApproveTypes[0];
      this.spExtraWorkApproveType = this.vacationApproveTypes[0];
    },
    FindSpecificExtraworkPermission() {
      var findSpecificExtraworkPermissionParams = {
        sectionid: this.args.id,
      };
      this.$store
        .dispatch("sections/findSpecificExtraworkPermission", { findSpecificExtraworkPermissionParams })
        .then((result) => {
          //console.log(result);
          if (result.type === ResultType.success) {
            if (result.data) {
              this.spExtraWorkApproveType = result.data;
            } else {
              this.spExtraWorkApproveType = "-1";
            }
          }
        });
    },
    findExtraPermission() {
      var findExtraWorkPermissionParams = {
        sectionid: this.args.id,
      };
      this.$store
        .dispatch("sections/findExtraWorkPermission", { findExtraWorkPermissionParams })
        .then((result) => {
          //console.log(result);
          if (result.type === ResultType.success) {
            if (result.data) {
              this.extraWorkApproveType = result.data;
            } else {
              this.extraWorkApproveType = "-1";
            }
          }
        });
    },
    findIOPermission() {
      var findIOPermissionParams = {
        sectionid: this.args.id,
      };
      this.$store.dispatch("sections/findIOPermission", { findIOPermissionParams }).then((result) => {
        //console.log(result);
        if (result.type === ResultType.success) {
          if (result.data) {
            this.ioApproveType = result.data;
          } else {
            this.ioApproveType = "-1";
          }
        }
      });
    },
    findMissionPermission() {
      if (this.missionType) {
        var findMissionPermissionParams = {
          sectionid: this.args.id,
          code: this.missionType.Code,
        };
        this.$store
          .dispatch("sections/findMissionPermission", { findMissionPermissionParams })
          .then((result) => {
            //console.log(result);
            if (result.type === ResultType.success) {
              if (result.data) {
                this.missionApproveType = result.data;
              } else {
                this.missionApproveType = "-1";
              }
            }
          });
      }
    },
    findVacationPermission() {
      console.log(this.vacationType);
      if (this.vacationType) {
        var findVacationPermissionParams = {
          sectionid: this.args.id,
          code: this.vacationType.Code,
        };
        this.$store
          .dispatch("sections/findVacationPermission", { findVacationPermissionParams })
          .then((result) => {
            //console.log(result);
            if (result.type === ResultType.success) {
              if (result.data) {
                this.vacationApproveType = result.data;
              } else {
                this.vacationApproveType = "-1";
              }
            }
          });
      }
    },
    loadMission() {
      this.$store.dispatch("GetWebMissionTypeList").then((result) => {
        //console.log(result);
        if (result.type === ResultType.success) {
          this.missionTypes = result.data;
          if (this.missionTypes.length > 0) {
            this.missionType = this.missionTypes[0];
            this.findMissionPermission();
          }
        }
      });
    },
    loadVacations() {
      this.$store.dispatch("GetWebVacationTypeList").then((result) => {
        //console.log(result);
        if (result.type === ResultType.success) {
          this.vacationTypes = result.data;
          if (this.vacationTypes.length > 0) {
            this.vacationType = this.vacationTypes[0];
            this.findVacationPermission();
          }
        }
      });
    },
    VacationApprove() {
      if (this.vacationApproveType != "-1") {
        var AddPatternDetailvacationPermissionParams = {
          sectionid: this.args.id,
          vacationCode: this.vacationType.Code,
          statusCode: this.vacationApproveType,
        };
        this.$store
          .dispatch("sections/AddPatternDetailvacationPermission", {
            AddPatternDetailvacationPermissionParams,
          })
          .then((result) => {
            console.log(result);
            if (result.type == ResultType.success) {
              this.$EosToast.show({
                type: EosToastType.success,
                msg: this.$t("operationSuccess"),
              });
            } else {
              this.$EosToast.show({
                type: EosToastType.error,
                msg: this.$t("operationFailed"),
              });
            }
            /*lblMsg.Text = (result.data) ? Properties.eosWinKartWebResource.approveRequest
          : Properties.eosWinKartWebResource.error;*/
          });
      } else {
        var DeletePatternDetailPermissionParams = {
          sectionid: this.args.id,
          code: this.vacationType.Code,
          pageKind: PageKind.PageKindType.Vacation,
        };
        //console.log(DeletePatternDetailPermissionPayload);
        this.$store
          .dispatch("sections/DeletePatternDetailPermission", {
            DeletePatternDetailPermissionParams,
          })
          .then((result) => {
            console.log(result);
            if (result.type == ResultType.success) {
              this.$EosToast.show({
                type: EosToastType.success,
                msg: "حذف سطح تایید با موفقیت انجام شد",
              });
            } else {
              this.$EosToast.show({
                type: EosToastType.error,
                msg: "در حذف سطح تایید خطایی رخ داده است",
              });
            }
          });
      }
    },
    MissionApprove() {
      if (this.missionApproveType != "-1") {
        var AddPatternDetailMissionPermissionParams = {
          sectionid: this.args.id,
          missionCode: this.missionType.Code,
          statusCode: this.missionApproveType,
        };
        this.$store
          .dispatch("sections/AddPatternDetailMissionPermission", {
            AddPatternDetailMissionPermissionParams,
          })
          .then((result) => {
            console.log(result);
            if (result.type == ResultType.success) {
              this.$EosToast.show({
                type: EosToastType.success,
                msg: this.$t("operationSuccess"),
              });
            } else {
              this.$EosToast.show({
                type: EosToastType.error,
                msg: this.$t("operationFailed"),
              });
            }
            /*lblMsg.Text = (result.data) ? Properties.eosWinKartWebResource.approveRequest
          : Properties.eosWinKartWebResource.error;*/
          });
      } else {
        var DeletePatternDetailPermissionParams = {
          sectionid: this.args.id,
          code: this.missionType.Code,
          pageKind: PageKind.PageKindType.Mission,
        };
        //console.log(DeletePatternDetailPermissionPayload);
        this.$store
          .dispatch("sections/DeletePatternDetailPermission", {
            DeletePatternDetailPermissionParams,
          })
          .then((result) => {
            console.log(result);
            if (result.type == ResultType.success) {
              this.$EosToast.show({
                type: EosToastType.success,
                msg: "حذف سطح تایید با موفقیت انجام شد",
              });
            } else {
              this.$EosToast.show({
                type: EosToastType.error,
                msg: "در حذف سطح تایید خطایی رخ داده است",
              });
            }
          });
      }
    },
    IoApprove() {
      if (this.ioApproveType != "-1") {
        var AddPatternDetailIoPermissionParams = {
          sectionid: this.args.id,
          statusCode: this.ioApproveType,
        };
        this.$store
          .dispatch("sections/AddPatternDetailIoPermission", {
            AddPatternDetailIoPermissionParams,
          })
          .then((result) => {
            console.log(result);
            if (result.type == ResultType.success) {
              this.$EosToast.show({
                type: EosToastType.success,
                msg: this.$t("operationSuccess"),
              });
            } else {
              this.$EosToast.show({
                type: EosToastType.error,
                msg: this.$t("operationFailed"),
              });
            }
            /*lblMsg.Text = (result.data) ? Properties.eosWinKartWebResource.approveRequest
          : Properties.eosWinKartWebResource.error;*/
          });
      } else {
        var DeletePatternDetailPermissionParams = {
          sectionid: this.args.id,
          code: "-1",
          pageKind: PageKind.PageKindType.IO,
        };
        //console.log(DeletePatternDetailPermissionPayload);
        this.$store
          .dispatch("sections/DeletePatternDetailPermission", {
            DeletePatternDetailPermissionParams,
          })
          .then((result) => {
            console.log(result);
            if (result.type == ResultType.success) {
              this.$EosToast.show({
                type: EosToastType.success,
                msg: "حذف سطح تایید با موفقیت انجام شد",
              });
            } else {
              this.$EosToast.show({
                type: EosToastType.error,
                msg: "در حذف سطح تایید خطایی رخ داده است",
              });
            }
          });
      }
    },
    ExtraWorkApprove() {
      if (this.extraWorkApproveType != "-1") {
        var AddPatternDetailExtraWorkPermissionParams = {
          sectionid: this.args.id,
          statusCode: this.extraWorkApproveType,
        };
        this.$store
          .dispatch("sections/AddPatternDetailExtraWorkPermission", {
            AddPatternDetailExtraWorkPermissionParams,
          })
          .then((result) => {
            console.log(result);
            if (result.type == ResultType.success) {
              this.$EosToast.show({
                type: EosToastType.success,
                msg: this.$t("operationSuccess"),
              });
            } else {
              this.$EosToast.show({
                type: EosToastType.error,
                msg: this.$t("operationFailed"),
              });
            }
            /*lblMsg.Text = (result.data) ? Properties.eosWinKartWebResource.approveRequest
          : Properties.eosWinKartWebResource.error;*/
          });
      } else {
        var DeletePatternDetailPermissionParams = {
          sectionid: this.args.id,
          code: "-1",
          pageKind: PageKind.PageKindType.ExtraWork,
        };
        //console.log(DeletePatternDetailPermissionPayload);
        this.$store
          .dispatch("sections/DeletePatternDetailPermission", {
            DeletePatternDetailPermissionParams,
          })
          .then((result) => {
            console.log(result);
            if (result.type == ResultType.success) {
              this.$EosToast.show({
                type: EosToastType.success,
                msg: "حذف سطح تایید با موفقیت انجام شد",
              });
            } else {
              this.$EosToast.show({
                type: EosToastType.error,
                msg: "در حذف سطح تایید خطایی رخ داده است",
              });
            }
          });
      }
    },
    EspecificExtraWorkApprove() {
      if (this.extraWorkApproveType != "-1") {
        var AddWebSectionDetailSpecificExtraWorkPermissionParams = {
          sectionid: this.args.id,
          statusCode: this.extraWorkApproveType,
        };
        this.$store
          .dispatch("sections/AddWebSectionDetailSpecificExtraWorkPermission", {
            AddWebSectionDetailSpecificExtraWorkPermissionParams,
          })
          .then((result) => {
            console.log(result);
            if (result.type == ResultType.success) {
              this.$EosToast.show({
                type: EosToastType.success,
                msg: this.$t("operationSuccess"),
              });
            } else {
              this.$EosToast.show({
                type: EosToastType.error,
                msg: this.$t("operationFailed"),
              });
            }
            /*lblMsg.Text = (result.data) ? Properties.eosWinKartWebResource.approveRequest
          : Properties.eosWinKartWebResource.error;*/
          });
      } else {
        var DeletePatternDetailPermissionParams = {
          sectionid: this.args.id,
          code: "-1",
          pageKind: PageKind.PageKindType.SpecificExtraWork,
        };
        //console.log(DeletePatternDetailPermissionPayload);
        this.$store
          .dispatch("sections/DeletePatternDetailPermission", {
            DeletePatternDetailPermissionParams,
          })
          .then((result) => {
            console.log(result);
            if (result.type == ResultType.success) {
              this.$EosToast.show({
                type: EosToastType.success,
                msg: "حذف سطح تایید با موفقیت انجام شد",
              });
            } else {
              this.$EosToast.show({
                type: EosToastType.error,
                msg: "در حذف سطح تایید خطایی رخ داده است",
              });
            }
          });
      }
    },
  },
};
</script>

<style>
.VacationApproveTypes {
  max-width: 200px;
}
</style>